import { Box, Stack, Typography, alpha } from '@mui/material';
import { resolveServiceIcon } from '../../constants/serviceIcons';
import type { HubService } from '../../constants/serviceHubs';

interface HubServiceTableCellProps {
  service: Pick<HubService, 'name' | 'icon' | 'themeColor'>;
  subtitle?: string;
  accentColor?: string;
}

export default function HubServiceTableCell({
  service, subtitle, accentColor = '#173A5E',
}: HubServiceTableCellProps) {
  const color = service.themeColor || accentColor;

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ width: '100%', minWidth: 0 }}>
      <Box
        sx={{
          width: 42,
          height: 42,
          flexShrink: 0,
          borderRadius: 1.75,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: alpha(color, 0.1),
          color,
          border: `1px solid ${alpha(color, 0.18)}`,
          '& svg': { fontSize: 20, width: 20, height: 20 },
        }}
      >
        {resolveServiceIcon(service.icon)}
      </Box>
      <Box minWidth={0}>
        <Typography variant="body2" fontWeight={700} noWrap title={service.name} sx={{ letterSpacing: '-0.015em' }}>
          {service.name}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" noWrap display="block" title={subtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
